import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';
// @ts-ignore
import {ReactComponent as arrow_right_bottom} from '../../../assets/arrows/edit/arrow_right_bottom.svg';

const ArrowRightBottom: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} component={arrow_right_bottom} viewBox='0 0 107 114' />
  );
};

export default ArrowRightBottom;
